export const ServiceText = [
	{
		service: 'Transferencia De Dinero Segura y Protegida',
		description: `Nuestros empleados capacitados pueden ayudarlo a enviar el efectivo que tanto le costó ganar a cualquier persona en todo el mundo de manera segura.
		Con nuestra red de transferencia de dinero de clase mundial, puede estar tranquilo sabiendo que su efectivo llega a su destino a tiempo y a la persona adecuada. Lo mismo aplica
		a cualquiera que desee recibir dinero enviado desde algún lugar del mundo. Visítenos con sus documentos listos para recibir efectivo, en el acto.`,
		icon: 'fas fa-money-bill-wave',
		subtitle: 'Envíe/reciba dinero fácil y rápido!',
		sequence: 'first'
	},

	{
		service: 'Todo Lo Que Necesita - Aquí',
		description: `Nuestra tienda está equipada con casi todo lo que una persona podría necesitar en el último momento en lugar de conducir muchos kilómetros. Si estas de humor
		para un refrigerio, ofrecemos de todo, desde papas fritas, dulces y galletas saladas. También proporcionamos productos importados de Ecuador, incluidos maíz, semillas de lino, hierbas,
		especias, frijoles, atún, harina de chuno y mucho más. ¿Me siento mal? - Visite nuestra tienda y podemos ofrecerle una selección de productos de venta libre.
		medicina para tratar la gripe, fiebre, dolores de cabeza, lesiones y otros.`,
		icon: 'fas fa-store',
		subtitle: 'Alimentos, bebidas, ropa y más disponibles aquí.',
		sequence: 'second'
	},

	{
		service: 'Fiabilidad Para Todas Sus Necesidades Financieras',
		description: `Nuestra reputación con nuestros clientes es muy valiosa para nosotros, ya que nos aseguramos de brindar el mejor servicio de calidad en nuestra comunidad.
		Nos complace ayudarlo con cualquier problema o pregunta que pueda tener, desde planificar su negocio de transferencia de dinero hasta brindar recomendaciones financieras.
		en su próxima visita. ¡Todo lo que tienes que hacer es preguntar!`,
		icon: 'fas fa-hands-helping',
		subtitle: 'Brindarle servicio de todos modos.',
		sequence: 'third'
	}
];

export const BannerList = {
	title: 'Premium Quality Service',
	subtitle: 'Fast, Easy & On Time',
	description: `"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
	path: '#',
	button: 'Learn about our shipping times',
	icon: 'fab fa-algolia',
	items: [
		{
			path: '#',
			icon: 'fas fa-file-alt list-item',
			title: ' Cras justo odio'
		},

		{
			path: '#',
			icon: 'fas fa-file-alt list-item',
			title: ' Dapibus ac facilisis in'
		},
		{
			path: '#',
			icon: 'fas fa-file-alt list-item',
			title: ' Morbi leo risus'
		}
	]
};

export const Label = {
	title: 'Nuestra Garantía Para Ti',
	subtitle: 'Nuestras metas',
	icon: 'fas fa-globe banner-title'
};
